module.exports = __webpack_public_path__ + "img/b1.7194d408.png";